import React from "react";
import { object } from "prop-types";
import { WithLazy, StoryElement, Link } from "@quintype/components";
import { getAttribution, isTemplateWithAds } from "../utils/story";
import { Ebook, ImageGalleryElement } from "../story-elements";
import { ImageSlideshow } from "./custom-story-elements/slideshow";
import { CustomTextElement } from "./custom-story-elements/text-element";
import { Attachment } from "./custom-story-elements/attachment";
import CustomPhotoStoryImageElement from "./custom-story-elements/photo-story-image";
import Table from "./custom-story-elements/table";
import { WithStoryAds } from "./WithStoryAds";

import "./blank.m.css";

const HeroStoryElementWrapper = ({ element, story }) => (
  <div styleName={story["story-template"] === "video" ? "video-wrapper" : ""}>
    <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
    {story["story-template"] === "video" && story?.cards?.[0]?.["story-elements"]?.[0]?.id === element?.id && (
      <>
        {story?.["hero-image-caption"] && (
          <div styleName="caption-image" dangerouslySetInnerHTML={{ __html: story?.["hero-image-caption"] }}></div>
        )}
        {story?.["hero-image-attribution"] && (
          <div styleName="caption-image-credit">
            {`Image Credit:`}
            <div dangerouslySetInnerHTML={{ __html: story?.["hero-image-attribution"] }}></div>
          </div>
        )}
      </>
    )}
  </div>
);

export const DefaultStoryCard = ({ card, story, allImagesInCards = {}, counter = {} }) => {
  const isPhotoStory = story?.["story-template"] === "photo";

  return (
    <>
      {card["story-elements"].map((element, index) => {
        const { type, subtype, metadata } = element;
        let componentToRender = null;
        if (type === "composite" && subtype === "image-gallery" && metadata?.type === "gallery") {
          componentToRender = (
            <WithLazy margin="50px" key={element.id}>
              {() => (
                <ImageGalleryElement
                  story={story}
                  widths={[132, 242]}
                  element={element}
                  key={element.id}
                  imageAspectRatio={[1, 1]}
                />
              )}
            </WithLazy>
          );
        } else if (type === "composite" && metadata?.type === "slideshow") {
          componentToRender = (
            <WithLazy margin="50px" key={element.id}>
              {() => <ImageSlideshow key={element.id} element={element} story={story} />}
            </WithLazy>
          );
        } else if (type === "composite" && subtype === "references") {
          componentToRender = <Ebook key={element.id} element={element} story={story} />;
        } else if (type === "jsembed" || type === "youtube-video" || element.subtype === "dailymotion-video") {
          componentToRender = (
            <WithLazy margin="50px" key={element.id}>
              {() => <HeroStoryElementWrapper element={element} story={story} />}
            </WithLazy>
          );
        } else if (type === "image") {
          const ImageElement = (
            <StoryElement
              element={{
                ...element,
                "image-attribution": getAttribution(element["image-attribution"]),
                title: getAttribution(element.title),
              }}
              key={element.id}
              story={story}
              loadIframeOnClick
            />
          );
          componentToRender = !isPhotoStory ? (
            <WithLazy margin="50px" key={element.id}>
              {() =>
                element?.hyperlink ? (
                  <Link href={element?.hyperlink} target="_blank">
                    {ImageElement}
                  </Link>
                ) : (
                  ImageElement
                )
              }
            </WithLazy>
          ) : (
            <CustomPhotoStoryImageElement
              key={element.id}
              element={element}
              story={story}
              allImagesInCards={allImagesInCards}
            />
          );
        } else if (type === "text" && subtype === null) {
          return <CustomTextElement key={element.id} element={element} story={story} counter={counter} />;
        } else if (type === "file" && subtype === "attachment") {
          componentToRender = <Attachment element={element} key={element.id} />;
        } else if (type === "data") {
          componentToRender = <Table element={element} key={element.id} story={story} />;
        } else {
          componentToRender = <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />;
        }

        const enableParagraphAds = isTemplateWithAds(story);

        return enableParagraphAds ? (
          <WithStoryAds key={element.id} counter={counter} componentToRender={componentToRender} story={story} />
        ) : (
          <>{componentToRender}</>
        );
      })}
    </>
  );
};

DefaultStoryCard.propTypes = {
  card: object,
  story: object,
};
